import { motion } from "motion/react";

export interface PricingFeature {
  key: string;
  title: string;
  detail: string;
}

interface PricingFeatureListProps {
  features: PricingFeature[];
  staggerDelay?: number;
}

export function PricingFeatureList({
  features,
  staggerDelay = 0.7,
}: PricingFeatureListProps) {
  return (
    <div className="text-muted-foreground space-y-2 text-base">
      {features.map(({ key, title }, i) => (
        <motion.div
          key={key}
          animate={{ opacity: 1, x: 0 }}
          className="flex items-start gap-2"
          initial={{ opacity: 0, x: -12 }}
          transition={{
            duration: 0.3,
            ease: [0.16, 1, 0.3, 1],
            delay: staggerDelay + i * 0.06,
          }}
        >
          <span className="text-profit pt-0.5">&#10003;</span>
          <div className="min-w-0 flex-1">
            <span>{title}</span>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
